import { render, staticRenderFns } from "./DownloadPowerpointModal.vue?vue&type=template&id=12ce32e6&scoped=true"
import script from "./DownloadPowerpointModal.vue?vue&type=script&lang=js"
export * from "./DownloadPowerpointModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadPowerpointModal.vue?vue&type=style&index=0&id=12ce32e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce32e6",
  null
  
)

export default component.exports